import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

/**
 * F-B3 · 入库订单（动态路由，登录后用户可见）
 *
 * 路径：/inbound-order/index
 * 父路由：BasicLayout（保留侧边栏 / 顶栏）
 */
const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:dolly',
      order: 4,
      title: '中转管理',
      keepAlive: true,
    },
    name: 'InboundOrderBase',
    path: '/inbound-order',
    redirect: '/inbound-order/all',
    children: [
      {
        component: () => import('#/views/workspace/parcel/index.vue'),
        meta: {
          icon: 'mdi:package-variant-closed',
          order: 0,
          title: '全部小包',
          keepAlive: true,
        },
        name: 'ParcelOverview',
        path: 'all',
      },
      {
        component: () => import('#/views/workspace/inbound-order/index.vue'),
        meta: {
          icon: 'mdi:archive-arrow-down-outline',
          order: 1,
          title: '入库订单',
          keepAlive: true,
        },
        name: 'InboundOrder',
        path: 'index',
      },
      {
        component: () => import('#/views/workspace/inventory-order/index.vue'),
        meta: {
          icon: 'mdi:warehouse',
          order: 2,
          title: '库存订单',
          keepAlive: true,
        },
        name: 'InventoryOrder',
        path: 'inventory',
      },
      {
        component: () => import('#/views/workspace/outbound-order/index.vue'),
        meta: {
          icon: 'mdi:archive-arrow-up-outline',
          order: 3,
          title: '出库订单',
          keepAlive: true,
        },
        name: 'OutboundOrder',
        path: 'outbound',
      },
      {
        component: () => import('#/views/workspace/unclaimed/index.vue'),
        meta: {
          icon: 'mdi:account-question-outline',
          order: 4,
          title: '无人认领',
          keepAlive: true,
        },
        name: 'UnclaimedPackage',
        path: 'unclaimed',
      },
    ],
  },
];

export default routes;
